import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard';
import { gql } from '@/utilities/gql';
import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query NarrativesRelatedBySlug($slug: ID!, $count: Int!) {
    narrative(ref: $slug) {
      company {
        canonicalCommunityUrl
      }
      related(count: $count) {
        ...NarrativeCardFields
      }
    }
  }
`,
  [NARRATIVE_CARD_FRAGMENT]
);

export const useNarrativesRelated = makeGqlSuspenseQuery(QUERY, {
  tags: ['narrative', 'narrative-related-list'],
  staleTime: 0,
});
